import { useTranslation } from "react-i18next";
import { ContentLoader, Text } from "shared/components/Spor";
import { StateContainer } from "shared/components/states/stateHelpers";

export const LargeLoadingState = () => {
  const { t } = useTranslation();

  return (
    <StateContainer minHeight="545px" gap={6} padding={4} border>
      <ContentLoader position="relative" />
      <Text my={0} textAlign="center" variant="md-lg">
        {t("Laster innhold")}
      </Text>
    </StateContainer>
  );
};
